export const getYear = state => state.reportCostCenterPerformance.getIn(['list', 'year'])
export const getData = state => state.reportCostCenterPerformance.getIn(['list', 'data'])
export const getFetching = state => state.reportCostCenterPerformance.getIn(['list', 'fetching'])
export const getError = state => state.reportCostCenterPerformance.getIn(['list', 'error'])

export const getDetailsData = state => state.reportCostCenterPerformance.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportCostCenterPerformance.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportCostCenterPerformance.getIn(['details', 'error'])
